import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { clarityTag, syncClarity } from "@/lib/clarity";
import { captureSignupRef, emailCampaignFromRef } from "@/lib/signup-ref";

/**
 * Runs on every route change:
 * - remembers `?ref=` from email links on whatever page the visitor lands on, so
 *   it is still there when they reach /register (not only on /get-started);
 * - starts/pauses Clarity (public pages only);
 * - tags the Clarity recording with the email campaign, if any.
 */
export default function Analytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const ref = captureSignupRef(search);
    syncClarity(pathname);
    const campaign = emailCampaignFromRef(ref);
    if (campaign) clarityTag("email_campaign", campaign);
  }, [pathname, search]);

  return null;
}
